// @ts-nocheck


import React from 'react';


import { batteryApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';




export default ({ filter = {}, ...selectProps }) =>
<AutocompleteSelect
  fetch={async (params) => {
    return await batteryApi.fetchBatteries({
      ...filter,
      ...params
    });
  }}
  refetchParams={{ filter }}
  fetchSingle={batteryApi.fetchBattery}
  notFoundText="АКБ не найдены"
  placeholder="Выберите АКБ"
  renderOption={(battery, Option) =>
  <Option key={battery.id} value={battery.id} battery={battery}>
        {battery.name}
      </Option>
  }
  {...selectProps} />;
